// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-login-page {
  --wallet-bg-1: #07131b;
  --wallet-bg-2: #0b1d29;
  --wallet-bg-3: #04080c;
  --wallet-emerald: #31e6a4;
  --wallet-gold: #f0ca73;
  --wallet-text: #f5f0e5;
  --wallet-text-soft: rgba(233, 238, 241, 0.76);
  --wallet-panel: rgba(7, 16, 22, 0.96);
  --wallet-border: rgba(100, 197, 170, 0.14);
  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  place-items: center;
  padding:
    calc(18px + var(--app-safe-top, 0px))
    calc(18px + var(--app-safe-right, 0px))
    calc(22px + var(--app-safe-bottom, 0px))
    calc(18px + var(--app-safe-left, 0px));
  position: relative;
  overflow: hidden;
  color: var(--wallet-text);
  background:
    radial-gradient(circle at top center, rgba(53, 109, 92, 0.26) 0%, rgba(7, 19, 27, 0) 34%),
    radial-gradient(circle at 18% 82%, rgba(240, 202, 115, 0.1) 0%, rgba(7, 19, 27, 0) 28%),
    linear-gradient(180deg, var(--wallet-bg-1) 0%, var(--wallet-bg-2) 52%, var(--wallet-bg-3) 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;
}

.wallet-login-page::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);
  background-size: 16px 16px;
  opacity: 0.52;
}

.wallet-login-shell {
  position: relative;
  width: min(100%, 440px);
  padding: 18px;
  border-radius: 28px;
  overflow: hidden;
  background: var(--wallet-panel);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 28px 56px rgba(0, 0, 0, 0.42);
}

.wallet-login-shell__noise,
.wallet-login-shell__halo {
  position: absolute;
  pointer-events: none;
}

.wallet-login-shell__noise {
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.014) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px);
  background-size: 12px 12px;
  opacity: 0.24;
}

.wallet-login-shell__halo {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  filter: blur(34px);
}

.wallet-login-shell__halo--top {
  top: -110px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(24, 180, 127, 0.14);
}

.wallet-login-shell__halo--bottom {
  right: -100px;
  bottom: -130px;
  background: rgba(240, 202, 115, 0.08);
}

.wallet-login-brand,
.wallet-login-card {
  position: relative;
  z-index: 1;
}

.wallet-login-brand {
  display: grid;
  gap: 12px;
  justify-items: center;
  text-align: center;
  margin-bottom: 18px;
}

.wallet-login-brand__logo {
  width: 102px;
  max-width: 40vw;
  object-fit: contain;
  filter: drop-shadow(0 14px 24px rgba(0, 0, 0, 0.34));
}

.wallet-login-card {
  display: grid;
  gap: 16px;
}

.wallet-login-error {
  padding: 12px 14px;
  border-radius: 16px;
  color: #ffd8d2;
  border: 1px solid rgba(255, 127, 114, 0.18);
  background: rgba(255, 127, 114, 0.08);
  text-align: left;
}

.wallet-login-form {
  display: grid;
  gap: 12px;
}

.wallet-login-field {
  display: grid;
  gap: 8px;
}

.wallet-login-field span {
  color: var(--wallet-text-soft);
  font-size: 0.79rem;
}

.wallet-login-field input,
.wallet-login-password {
  min-height: 50px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
  color: var(--wallet-text);
}

.wallet-login-field input {
  padding: 0 16px;
}

.wallet-login-field input::placeholder {
  color: rgba(233, 238, 241, 0.48);
}

.wallet-login-field input:disabled,
.wallet-login-password input:disabled {
  opacity: 0.82;
}

.wallet-login-field input:focus,
.wallet-login-password input:focus,
.wallet-login-password button:focus-visible,
.wallet-login-primary:focus-visible,
.wallet-login-remember input:focus-visible {
  outline: 2px solid rgba(49, 230, 164, 0.5);
  outline-offset: 2px;
}

.wallet-login-password {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.wallet-login-password input {
  flex: 1 1;
  min-height: 48px;
  border: 0;
  padding: 0 16px;
  background: transparent;
}

.wallet-login-password button {
  min-width: 84px;
  height: 100%;
  border: 0;
  background: transparent;
  color: var(--wallet-emerald);
  cursor: pointer;
  padding: 0 14px;
}

.wallet-login-password button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.wallet-login-remember {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--wallet-text-soft);
  font-size: 0.86rem;
}

.wallet-login-remember input {
  width: 18px;
  height: 18px;
  accent-color: var(--wallet-emerald);
}

.wallet-login-primary {
  min-height: 50px;
  border: 1px solid rgba(49, 230, 164, 0.3);
  border-radius: 14px;
  color: #e7fff7;
  font-weight: 700;
  font-size: 0.96rem;
  cursor: pointer;
  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.14),
    0 12px 24px rgba(0, 0, 0, 0.22),
    0 0 22px rgba(49, 230, 164, 0.14);
  transition: transform 180ms ease, filter 180ms ease, box-shadow 180ms ease;
}

.wallet-login-secondary {
  min-height: 44px;
  border-radius: 13px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  color: var(--wallet-text-soft);
  font-size: 0.88rem;
  cursor: pointer;
  transition: transform 180ms ease, filter 180ms ease, box-shadow 180ms ease;
}

.wallet-login-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: brightness(1.03);
}

.wallet-login-secondary:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: brightness(1.03);
}

.wallet-login-primary:disabled {
  opacity: 0.64;
  cursor: not-allowed;
}

.wallet-login-secondary:disabled {
  opacity: 0.64;
  cursor: not-allowed;
}

.wallet-login-actions {
  text-align: center;
  padding-top: 2px;
}

.wallet-login-actions a {
  color: var(--wallet-text-soft);
  font-size: 0.84rem;
}

.wallet-login-actions a:hover {
  color: var(--wallet-text);
}

@media (max-width: 480px) {
  .wallet-login-page {
    padding:
      calc(12px + var(--app-safe-top, 0px))
      calc(12px + var(--app-safe-right, 0px))
      calc(16px + var(--app-safe-bottom, 0px))
      calc(12px + var(--app-safe-left, 0px));
  }

  .wallet-login-shell {
    width: min(100%, 420px);
    padding: 18px;
    border-radius: 24px;
  }

  .wallet-login-brand {
    gap: 12px;
    margin-bottom: 18px;
  }

  .wallet-login-brand h1 {
    font-size: clamp(1.25rem, 6vw, 1.7rem);
  }

  .wallet-login-field input,
  .wallet-login-password,
  .wallet-login-primary,
  .wallet-login-secondary {
    min-height: 48px;
    border-radius: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,6CAA6C;EAC7C,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB;;;;0CAIwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB;;;mGAGiG;EACjG,wFAAwF;AAC1F;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;2EAEyE;EACzE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;EAKE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6FAA6F;EAC7F;;;qCAGmC;EACnC,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE;;;;4CAIwC;EAC1C;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;;;;IAIE,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".wallet-login-page {\n  --wallet-bg-1: #07131b;\n  --wallet-bg-2: #0b1d29;\n  --wallet-bg-3: #04080c;\n  --wallet-emerald: #31e6a4;\n  --wallet-gold: #f0ca73;\n  --wallet-text: #f5f0e5;\n  --wallet-text-soft: rgba(233, 238, 241, 0.76);\n  --wallet-panel: rgba(7, 16, 22, 0.96);\n  --wallet-border: rgba(100, 197, 170, 0.14);\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: grid;\n  place-items: center;\n  padding:\n    calc(18px + var(--app-safe-top, 0px))\n    calc(18px + var(--app-safe-right, 0px))\n    calc(22px + var(--app-safe-bottom, 0px))\n    calc(18px + var(--app-safe-left, 0px));\n  position: relative;\n  overflow: hidden;\n  color: var(--wallet-text);\n  background:\n    radial-gradient(circle at top center, rgba(53, 109, 92, 0.26) 0%, rgba(7, 19, 27, 0) 34%),\n    radial-gradient(circle at 18% 82%, rgba(240, 202, 115, 0.1) 0%, rgba(7, 19, 27, 0) 28%),\n    linear-gradient(180deg, var(--wallet-bg-1) 0%, var(--wallet-bg-2) 52%, var(--wallet-bg-3) 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;\n}\n\n.wallet-login-page::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);\n  background-size: 16px 16px;\n  opacity: 0.52;\n}\n\n.wallet-login-shell {\n  position: relative;\n  width: min(100%, 440px);\n  padding: 18px;\n  border-radius: 28px;\n  overflow: hidden;\n  background: var(--wallet-panel);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 28px 56px rgba(0, 0, 0, 0.42);\n}\n\n.wallet-login-shell__noise,\n.wallet-login-shell__halo {\n  position: absolute;\n  pointer-events: none;\n}\n\n.wallet-login-shell__noise {\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.014) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px);\n  background-size: 12px 12px;\n  opacity: 0.24;\n}\n\n.wallet-login-shell__halo {\n  width: 220px;\n  height: 220px;\n  border-radius: 50%;\n  filter: blur(34px);\n}\n\n.wallet-login-shell__halo--top {\n  top: -110px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(24, 180, 127, 0.14);\n}\n\n.wallet-login-shell__halo--bottom {\n  right: -100px;\n  bottom: -130px;\n  background: rgba(240, 202, 115, 0.08);\n}\n\n.wallet-login-brand,\n.wallet-login-card {\n  position: relative;\n  z-index: 1;\n}\n\n.wallet-login-brand {\n  display: grid;\n  gap: 12px;\n  justify-items: center;\n  text-align: center;\n  margin-bottom: 18px;\n}\n\n.wallet-login-brand__logo {\n  width: 102px;\n  max-width: 40vw;\n  object-fit: contain;\n  filter: drop-shadow(0 14px 24px rgba(0, 0, 0, 0.34));\n}\n\n.wallet-login-card {\n  display: grid;\n  gap: 16px;\n}\n\n.wallet-login-error {\n  padding: 12px 14px;\n  border-radius: 16px;\n  color: #ffd8d2;\n  border: 1px solid rgba(255, 127, 114, 0.18);\n  background: rgba(255, 127, 114, 0.08);\n  text-align: left;\n}\n\n.wallet-login-form {\n  display: grid;\n  gap: 12px;\n}\n\n.wallet-login-field {\n  display: grid;\n  gap: 8px;\n}\n\n.wallet-login-field span {\n  color: var(--wallet-text-soft);\n  font-size: 0.79rem;\n}\n\n.wallet-login-field input,\n.wallet-login-password {\n  min-height: 50px;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n  color: var(--wallet-text);\n}\n\n.wallet-login-field input {\n  padding: 0 16px;\n}\n\n.wallet-login-field input::placeholder {\n  color: rgba(233, 238, 241, 0.48);\n}\n\n.wallet-login-field input:disabled,\n.wallet-login-password input:disabled {\n  opacity: 0.82;\n}\n\n.wallet-login-field input:focus,\n.wallet-login-password input:focus,\n.wallet-login-password button:focus-visible,\n.wallet-login-primary:focus-visible,\n.wallet-login-remember input:focus-visible {\n  outline: 2px solid rgba(49, 230, 164, 0.5);\n  outline-offset: 2px;\n}\n\n.wallet-login-password {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.wallet-login-password input {\n  flex: 1;\n  min-height: 48px;\n  border: 0;\n  padding: 0 16px;\n  background: transparent;\n}\n\n.wallet-login-password button {\n  min-width: 84px;\n  height: 100%;\n  border: 0;\n  background: transparent;\n  color: var(--wallet-emerald);\n  cursor: pointer;\n  padding: 0 14px;\n}\n\n.wallet-login-password button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.wallet-login-remember {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--wallet-text-soft);\n  font-size: 0.86rem;\n}\n\n.wallet-login-remember input {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--wallet-emerald);\n}\n\n.wallet-login-primary {\n  min-height: 50px;\n  border: 1px solid rgba(49, 230, 164, 0.3);\n  border-radius: 14px;\n  color: #e7fff7;\n  font-weight: 700;\n  font-size: 0.96rem;\n  cursor: pointer;\n  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.14),\n    0 12px 24px rgba(0, 0, 0, 0.22),\n    0 0 22px rgba(49, 230, 164, 0.14);\n  transition: transform 180ms ease, filter 180ms ease, box-shadow 180ms ease;\n}\n\n.wallet-login-secondary {\n  min-height: 44px;\n  border-radius: 13px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--wallet-text-soft);\n  font-size: 0.88rem;\n  cursor: pointer;\n  transition: transform 180ms ease, filter 180ms ease, box-shadow 180ms ease;\n}\n\n.wallet-login-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  filter: brightness(1.03);\n}\n\n.wallet-login-secondary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  filter: brightness(1.03);\n}\n\n.wallet-login-primary:disabled {\n  opacity: 0.64;\n  cursor: not-allowed;\n}\n\n.wallet-login-secondary:disabled {\n  opacity: 0.64;\n  cursor: not-allowed;\n}\n\n.wallet-login-actions {\n  text-align: center;\n  padding-top: 2px;\n}\n\n.wallet-login-actions a {\n  color: var(--wallet-text-soft);\n  font-size: 0.84rem;\n}\n\n.wallet-login-actions a:hover {\n  color: var(--wallet-text);\n}\n\n@media (max-width: 480px) {\n  .wallet-login-page {\n    padding:\n      calc(12px + var(--app-safe-top, 0px))\n      calc(12px + var(--app-safe-right, 0px))\n      calc(16px + var(--app-safe-bottom, 0px))\n      calc(12px + var(--app-safe-left, 0px));\n  }\n\n  .wallet-login-shell {\n    width: min(100%, 420px);\n    padding: 18px;\n    border-radius: 24px;\n  }\n\n  .wallet-login-brand {\n    gap: 12px;\n    margin-bottom: 18px;\n  }\n\n  .wallet-login-brand h1 {\n    font-size: clamp(1.25rem, 6vw, 1.7rem);\n  }\n\n  .wallet-login-field input,\n  .wallet-login-password,\n  .wallet-login-primary,\n  .wallet-login-secondary {\n    min-height: 48px;\n    border-radius: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
